import React, { useState, useEffect, useRef } from "react";
import {
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Box,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  useToast,
  ModalBody,
  ModalCloseButton,
  Image,
  Select,
  useBreakpointValue,
  Badge,
  Switch, 
  SimpleGrid,
  Textarea,
  FormControl,
  FormLabel,
  HStack,
} from "@chakra-ui/react";
import { IoMdEye } from "react-icons/io";
import { MdDelete, MdEdit, MdDone, MdCancel, MdAdd, MdRemove, MdCategory } from "react-icons/md";
import Card from "components/card/Card";
import fetchWithToken from "views/auth/signIn/axiosInstance"; // Adjust the path
import InsertServices from "./InsertServices";
import ServiceType from "./ServiceType";
import ListServicesTypes from "./listServicesTypes";
import { useTranslation } from "react-i18next";
import ListItemServices from "./listItemServices";
import LaundryCategories from "./LaundryCategories";
import ServiceCategories from "./ServiceCategories";
import ListServiceCategories from "./ListServiceCategories";

const ListServices = ({ showInsertForm, setShowInsertForm, showTypeForm, setShowTypeForm }) => {
  const { t } = useTranslation();
  const [Services, setServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [error, setError] = useState("");
  const [editableService, setEditableService] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedServiceForItems, setSelectedServiceForItems] = useState(null); // Store service object instead of just ID
  const [showInsertServiceForm, setShowInsertServiceForm] = useState(false);
  const [showServiceTypeForm, setShowServiceTypeForm] = useState(false);    
  const [selectedServiceId, setSelectedServiceId] = useState(false);
  const [showLaundryCategoriesForm, setShowLaundryCategoriesForm] = useState(false);
  const [showServiceCategoriesForm, setShowServiceCategoriesForm] = useState(false);
  // Service Categories Management Modal States
  const [showServiceCategoriesModal, setShowServiceCategoriesModal] = useState(false);
  const [selectedServiceForCategories, setSelectedServiceForCategories] = useState(null);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [showAddCategoryForm, setShowAddCategoryForm] = useState(false);
  const modalSize = useBreakpointValue({ base: "full", md: "3xl" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const [newCategory, setNewCategory] = useState({
    name: "",
    translation_key: "",
    image: "",
    translations: {
      en: "",
      ar: ""
    }
  });
  const [categoryImageChanged, setCategoryImageChanged] = useState(false); // Track if image was changed
  const imageInputRef = useRef(null); // Reference for the image input
  const representativeImageInputRef = useRef(null); // Reference for the representative image input
  const toast = useToast();
  const pageId = 13; // Page ID for services management
  const [permissions, setPermissions] = useState({ canList: true, canEdit: true, canDelete: true, canInsert: true });
  useEffect(() => {
    try {
      const role = JSON.parse(sessionStorage.getItem("permissions") || "{}");
      if (!role.permissions) {
        toast({
          title: "No permissions found",
          description: error.message || "You don't have the required access.",
          status: "error",
          duration: 3000,
          isClosable: true,
position: "top-right",

        });
        return;
      }

      const permission = role.permissions.find((p) => p.page_id === pageId);
      if (permission) {
        setPermissions({
          canList: permission.read_all_access || false,
          canEdit: permission.update_access || false,
          canDelete: permission.delete_access || false,
          canInsert: permission.insert_access || false,
        });
      }
    } catch (error) {
      toast({
        title: "Error loading permissions",
        description: error.message || "Something went wrong while fetching permissions.",
        status: "error",
        duration: 3000,
        isClosable: true,
position: "top-right",

      });
    }
  }, [toast, error.message]);
  
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const url = `${process.env.REACT_APP_API_URL}/services?page_id=${pageId}`;
        const data = await fetchWithToken(url);
        const servicesData = Array.isArray(data.data) ? data.data : [];
        setServices(servicesData);
        setFilteredServices(servicesData);
      } catch (error) {
        console.error("Error fetching services:", error);
        setServices([]);
        setFilteredServices([]);
        toast({
          title: "Service failed to fetched.",
          status: "error",
          duration: 2500,
          isClosable: true,
position: "top-right",

        });
      }
    };
      fetchServices();
  }, [toast, pageId]);

  const handleDeleteService = async (ServiceId) => {
    try {
      await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/services/service/delete?service_id=${ServiceId}&page_id=${pageId}`,
        "DELETE"
      );
      setServices(Array.isArray(Services) ? Services.filter((service) => service.id !== ServiceId) : []);
      setFilteredServices(Array.isArray(filteredServices) ? filteredServices.filter((service) => service.id !== ServiceId) : []);
    } catch (error) {
      console.error("Error deleting service:", error);
      setError("Failed to delete service");
    }
  };  const handleEditService = (service) => {
    // Make sure all required fields are properly mapped
    const formattedService = {
      ...service,
      name: service.name || service.service_name,
      description: service.description || service.service_description,
      image: service.image || service.image_url,
      representative_image: service.representative_image,
    };
    setEditableService(formattedService);
  }; 
  const handleSaveService = async () => {
  try {
    setIsSubmitting(true);

    // Prepare update payload
    const updatedTranslations = {};
    if (
      editableService.translations?.it !==
      Services.find((s) => s.id === editableService.id)?.translations?.it
    ) {
      updatedTranslations.it = editableService.translations?.it;
    }
    if (
      editableService.translations?.fr !==
      Services.find((s) => s.id === editableService.id)?.translations?.fr
    ) {
      updatedTranslations.fr = editableService.translations?.fr;
    }

    const data = {
      service_id: editableService.id,
      name: editableService.name || editableService.service_name,
      description: editableService.description || editableService.service_description,
      status: editableService.status,
      fee: parseFloat(editableService.fee) || 0,
      translations: updatedTranslations, // Only send updated translations
    };

    // Only include the image if it has been updated
    if (editableService.image && imageInputRef?.current?.files[0]) {
      data.image = editableService.image;
    }

    // Only include the representative image if it has been updated
    if (
      editableService.representative_image &&
      representativeImageInputRef?.current?.files[0]
    ) {
      data.representative_image = editableService.representative_image;
    }

    // API call
    const response = await fetchWithToken(
      `${process.env.REACT_APP_API_URL}/services/service/update?page_id=${pageId}`,
      "PATCH",
      data
    );

    if (!response) throw new Error("Failed to update service");

    // Update state lists
    setServices((prevServices) =>
      Array.isArray(prevServices)
        ? prevServices.map((service) =>
            service.id === editableService.id
              ? { ...service, ...editableService }
              : service
          )
        : []
    );

    setFilteredServices((prevFilteredServices) =>
      Array.isArray(prevFilteredServices)
        ? prevFilteredServices.map((service) =>
            service.id === editableService.id
              ? { ...service, ...editableService }
              : service
          )
        : []
    );

    // Clear file inputs
    if (imageInputRef?.current) imageInputRef.current.value = "";
    if (representativeImageInputRef?.current) representativeImageInputRef.current.value = "";

    // Close modal
    setEditableService(null);

    // ✅ Success toast
    toast({
      title: "Service updated successfully.",
      status: "success",
      duration: 4000,
      isClosable: true,
      position: "top-right",
    });
  } catch (error) {
    console.error("Error updating service:", error);
    toast({
      title: "Error updating service.",
      description: error.message || "An unexpected error occurred.",
      status: "error",
      duration: 5000,
      isClosable: true,
      position: "top-right",
    });
  } finally {
    setIsSubmitting(false);
  }
};

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    
    // Ensure Services is an array before filtering
    if (!Array.isArray(Services)) {
      setFilteredServices([]);
      return;
    }
    
    const filtered = Services.filter((service) =>
      service._id
        ? service.service_name?.toLowerCase().includes(query.toLowerCase())
        : (service.servicetype_name || service.package_name || service.name || "").toLowerCase().includes(query.toLowerCase())
    );
    setFilteredServices(filtered);
  };


  return (
    <>
      <Card
        direction="column"
        w="100%"
        px="0px"
        overflowX={{ base: "scroll", lg: "hidden" }}
        boxShadow="lg"
      >
        <Flex
          px={{ base: "15px", md: "35px" }}
          justify="space-between"
          mb="20px"
          align="center"
          flexWrap="wrap"
        >
          <Text
                color="black"
                fontSize={{ base: "18px", md: "22px" }}
                fontWeight="700"
                lineHeight="100%"
              >
                {t("Services List")}
          </Text>
        </Flex>

        <Flex
          px={{ base: "10px", md: "25px" }}
          justify="space-between"
          mb="20px"
          align="center"
          flexWrap="wrap"
        >
          <Flex align="center">
            <Button
              onClick={() => setShowInsertServiceForm(!showInsertServiceForm)}
              isDisabled={!permissions.canInsert}
              ml={2}
              leftIcon={showInsertServiceForm ? <MdRemove /> : <MdAdd />}
              colorScheme={showInsertServiceForm ? "red" : "cyan"}
              color="white"

              p={4}
              borderRadius="full"
              boxShadow="md"
              _hover={{
                bg: showInsertServiceForm ? "red.600" : "cyan.600",
                transform: "scale(1.05)",
              }}
              _active={{
                bg: showInsertServiceForm ? "red.700" : "cyan.700",
                transform: "scale(0.95)",
              }}
              transition="all 0.2s"
            >
              {showInsertServiceForm ? t("Service") : t("Service")}
            </Button>
            <Button
              onClick={() => setShowServiceTypeForm(!showServiceTypeForm)}
              ml={2}
              isDisabled={!permissions.canInsert}
              leftIcon={showServiceTypeForm ? <MdRemove /> : <MdAdd />}
              colorScheme={showServiceTypeForm ? "red" : "cyan"}
              color="white"
              p={4}
              borderRadius="full"
              boxShadow="md"
              _hover={{
                bg: showServiceTypeForm ? "red.600" : "cyan.600",
                transform: "scale(1.05)",
              }}
              _active={{
                bg: showServiceTypeForm ? "red.700" : "cyan.700",
                transform: "scale(0.95)",
              }}
              transition="all 0.2s"            >
              {showServiceTypeForm ? t("Service Type") : t("Service Type")}
            </Button>
            <Button
              onClick={() => setShowLaundryCategoriesForm(!showLaundryCategoriesForm)}
              ml={2}
              isDisabled={!permissions.canInsert}
              leftIcon={showLaundryCategoriesForm ? <MdRemove /> : <MdAdd />}
              colorScheme={showLaundryCategoriesForm ? "red" : "cyan"}
              color="white"
              p={2}
              borderRadius="full"
              boxShadow="md"
              _hover={{
                bg: showLaundryCategoriesForm ? "red.600" : "cyan.600",
                transform: "scale(1.05)",
              }}
              _active={{
                bg: showLaundryCategoriesForm ? "red.700" : "cyan.700",
                transform: "scale(0.95)",
              }}
              transition="all 0.2s"            >
              {showLaundryCategoriesForm ? t("Laundry Categories") : t("Laundry Categories")}
            </Button>
            <Button
              onClick={() => setShowServiceCategoriesForm(!showServiceCategoriesForm)}
              ml={2}
              isDisabled={!permissions.canInsert}
              leftIcon={showServiceCategoriesForm ? <MdRemove /> : <MdAdd />}
              colorScheme={showServiceCategoriesForm ? "red" : "cyan"}
              color="white"
              p={2}
              borderRadius="full"
              boxShadow="md"
              _hover={{
                bg: showServiceCategoriesForm ? "red.600" : "cyan.600",
                transform: "scale(1.05)",
              }}
              _active={{
                bg: showServiceCategoriesForm ? "red.700" : "cyan.700",
                transform: "scale(0.95)",
              }}
              transition="all 0.2s"
            >
              {showServiceCategoriesForm ? t("Service Categories") : t("Service Categories")}
            </Button>
            <Button
              colorScheme="cyan"
              size="md"
              ml={2}
              onClick={() => setSelectedServiceId(true)}
              color="white"
              borderRadius="full"
              boxShadow="md"
              _hover={{
                bg: showServiceCategoriesForm ? "red.600" : "cyan.600",
                transform: "scale(1.05)",
              }}
              _active={{
                bg: showServiceCategoriesForm ? "red.700" : "cyan.700",
                transform: "scale(0.95)",
              }}
              transition="all 0.2s"
            >
              <IoMdEye />
            </Button>
          </Flex>
          {error && <Text color="red.500">{error}</Text>}
          <Input
            placeholder={t("Search services")}
            value={searchQuery}
            onChange={handleSearch}
            size="sm"
            w={{ base: "100%", md: "200px" }}
            mt={{ base: 2, md: 0 }}
          />
        </Flex>

        {/* Insert Service Modal */}
        <Modal
          isOpen={showInsertServiceForm}
          onClose={() => setShowInsertServiceForm(false)}
          size={modalSize}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("Insert Service")}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <InsertServices />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                mr={3}
                onClick={() => setShowInsertServiceForm(false)}
              >
                {t("Close")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>        {/* Insert Service Type Modal */}
        <Modal
          isOpen={showServiceTypeForm}
          onClose={() => setShowServiceTypeForm(false)}
          size={modalSize}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("Insert Service Type")}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <ServiceType />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                mr={3}
                onClick={() => setShowServiceTypeForm(false)}
              >
                {t("Close")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Laundry Categories Modal */}
       <Modal
          isOpen={showLaundryCategoriesForm}
          onClose={() => setShowLaundryCategoriesForm(false)}
          size="6xl"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("Laundry Categories Management")}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <LaundryCategories />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                mr={3}
                onClick={() => setShowLaundryCategoriesForm(false)}
              >
                {t("Close")}
              </Button>
            </ModalFooter>          </ModalContent>
        </Modal>

        {/* Service Categories Modal */}
        <Modal
          isOpen={showServiceCategoriesForm}
          onClose={() => setShowServiceCategoriesForm(false)}
          size="6xl"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("Service Categories Management")}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <ServiceCategories />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                mr={3}
                onClick={() => setShowServiceCategoriesForm(false)}
              >
                {t("Close")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Insert Item Service Modal */}
       <Modal isOpen={selectedServiceForItems} onClose={() => setSelectedServiceForItems(null)}>
  <ModalOverlay />
  <ModalContent maxWidth="80%"> {/* Adjust the percentage or use a specific width like "1200px" */}
    <ModalHeader>{t("Item Service")}</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      {/* Pass the selected service id and service code to the ListItemServices component */}
      <ListItemServices 
        serviceId={selectedServiceForItems?.id} 
        serviceCode={selectedServiceForItems?.code}
      />
    </ModalBody>
    <ModalFooter>
      <Button
        colorScheme="cyan"
        color="white"
        mr={3}
        onClick={() => setSelectedServiceForItems(null)}
      >
        {t("Close")}
      </Button>
    </ModalFooter>
  </ModalContent>
</Modal>
              {/* List Service  Modal */}
        <Modal
          size={"7xl"}
          isOpen={selectedServiceId}
          onClose={() => setSelectedServiceId(false)}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{t("List Services Types")}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <ListServicesTypes  />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                mr={3}
                onClick={() => setSelectedServiceId(false)}
              >
                {t("Close")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Service Categories Management Modal */}
       

  <Modal 
 isOpen={!!selectedServiceForCategories}
  onClose={() => setSelectedServiceForCategories(null)}
  size="6xl"
  >
          <ModalOverlay />
          <ModalContent>
  <ModalHeader>
      {t("Manage Categories for")} "{selectedServiceForCategories?.name}"
    </ModalHeader>            <ModalCloseButton />            
            <ModalBody>
              {/* Pass the selected service id and service code to the ListItemServices component */}
               <ListServiceCategories
        serviceId={selectedServiceForCategories?.id}
        serviceName={selectedServiceForCategories?.name}
      />
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                mr={3}
               onClick={() => setSelectedServiceForCategories(null)}
              >
                {t("Close")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal> 
        <Box overflowY="auto" maxHeight="350px">
          <Table variant="simple" color="gray.500" mb="24px">            
             <Thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                          <Tr bg='rgb(69, 50, 240)' textColor="white" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                <Th textColor="white">{t("Index")}</Th>
                <Th textColor="white">{t("Name")}</Th>
                <Th textColor="white">{t("Description")}</Th>
                <Th textColor="white">{t("Fee")}</Th>
                <Th textColor="white">{t("Image")}</Th>
                <Th textColor="white">{t("Service Profile")}</Th>
                <Th textColor="white">{t("Translations")}</Th>
                <Th textColor="white">{t("Status")}</Th>
                <Th textColor="white">{t("Actions")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {Array.isArray(filteredServices) && filteredServices.map((service, index) => (
                <Tr key={service.id}>
                  <Td>{index + 1}</Td>                  <Td>
                    {editableService && editableService.id === service.id ? (
                      <Input
                        value={editableService.name || ""}
                        onChange={(e) =>
                          setEditableService({
                            ...editableService,
                            name: e.target.value,
                          })
                        }
                      />
                    ) : (
                      service.id ? service.name : ""
                    )}
                  </Td>               
                     <Td>
                    {editableService && editableService.id === service.id ? (
                        <Input
                          value={editableService.description || ""}
                          onChange={(e) =>
                            setEditableService({
                              ...editableService,
                              description: e.target.value,
                            })
                          }
                        />
                      ) : (
                        service.description? service.description: ""
                    )}
                  </Td>
                  <Td>
                    {editableService && editableService.id === service.id ? (
                      <Input
                        type="number"
                        value={editableService.fee || ""}
                        onChange={(e) =>
                          setEditableService({
                            ...editableService,
                            fee: e.target.value,
                          })
                        }
                      />
                    ) : (
                      service.fee ? service.fee : ""
                    )}
                  </Td>
                  <Td>
                    {editableService && editableService.id === service.id ? (
                      <Flex direction="column" align="center">
                        {editableService.image && (
                          <Image
                            src={editableService.image}
                            alt={editableService.name}
                            boxSize="50px"
                            objectFit="cover"
                            borderRadius="md"
                            mb={2}
                          />
                        )}                        
                        <Input
                          type="file"
                          accept="image/*"
                          ref={imageInputRef}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setEditableService({
                                  ...editableService,
                                  image: reader.result, // Store the image data with correct field name
                                });
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                        />
                      </Flex>
                    ) : (
                      service.image ? (
                        <Image
                          src={service.image}
                          alt={service.name}
                          boxSize="50px"
                          objectFit="cover"
                          borderRadius="md"
                        />
                      ) : (
                        service.image_url ? (
                          <Image
                            src={service.image_url}
                            alt={service.name}
                            boxSize="50px"
                            objectFit="cover"
                            borderRadius="md"
                          />
                        ) : (
                          <Text>{t("No Image")}</Text>
                        )
                      )
                    )}                  
                  </Td>
                  <Td>
                    {editableService && editableService.id === service.id ? (
                      <Flex direction="column" align="center">
                        {editableService.representative_image && (
                          <Image
                            src={editableService.representative_image}
                            alt={`${editableService.name} profile`}
                            boxSize="50px"
                            objectFit="cover"
                            borderRadius="md"
                            mb={2}
                          />
                        )}
                        <Input
                          type="file"
                          accept="image/*"                          ref={representativeImageInputRef}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setEditableService({
                                  ...editableService,
                                  representative_image: reader.result,
                                });
                              };
                              reader.readAsDataURL(file);
                            }
                          }}
                        />
                      </Flex>
                    ) : (
                      service.representative_image ? (
                        <Image
                          src={service.representative_image}
                          alt={`${service.name} profile`}
                          boxSize="50px"
                          objectFit="cover"
                          borderRadius="md"
                        />
                      ) : (
                        <Text>{t("No Image")}</Text>
                      )
                    )}
                  </Td>
                     <Td>
                              {editableService && editableService.id === service.id ? (
                                <Flex direction="column" gap={2}>
                                  <Flex align="center">
                                    <Text fontWeight="bold" minWidth="55px" mr={2}>
                                      Key:
                                    </Text>
                                    <Input
                                      borderColor="gray.300"
                                      value={editableService.translation_key || ""}
                                      onChange={(e) =>
                                        setEditableService({
                                          ...editableService,
                                          translation_key: e.target.value,
                                        })
                                      }
                                      size="sm"
                                    />
                                  </Flex>
                                  <Flex align="center">
                                    <Text fontWeight="bold" minWidth="55px" mr={2}>
                                      IT:
                                    </Text>
                                    <Input
                                      borderColor="gray.300"
                                      value={editableService.translations?.it || ""}
                                      onChange={(e) =>
                                        setEditableService({
                                          ...editableService,
                                          translations: {
                                            ...editableService.translations,
                                            it: e.target.value,
                                          },
                                        })
                                      }
                                      size="sm"
                                    />
                                  </Flex>
                                  <Flex align="center">
                                    <Text fontWeight="bold" minWidth="55px" mr={2}>
                                      FR:
                                    </Text>
                                    <Input
                                      borderColor="gray.300"
                                      value={editableService.translations?.fr || ""}
                                      onChange={(e) =>
                                        setEditableService({
                                          ...editableService,
                                          translations: {
                                            ...editableService.translations,
                                            fr: e.target.value,
                                          },
                                        })
                                      }
                                      size="sm"
                                    />
                                  </Flex>
                                </Flex>
                              ) : (
                                <Flex direction="column">
                                  {service.translation_key && (
                                    <Text fontSize="sm" fontWeight="medium" whiteSpace="pre-wrap" wordBreak="break-word">
                                      Key: {service.translation_key}
                                    </Text>
                                  )}
                                  {service.translations?.it && (
                                    <Text fontSize="sm" whiteSpace="pre-wrap" wordBreak="break-word">
                                      IT: {service.translations.it}
                                    </Text>
                                  )}
                                  {service.translations?.fr && (
                                    <Text fontSize="sm" whiteSpace="pre-wrap" wordBreak="break-word">
                                      FR: {service.translations.fr}
                                    </Text>
                                  )}
                                  {!service.translation_key &&
                                    !service.translations?.it &&
                                    !service.translations?.fr && (
                                      <Text fontSize="sm" color="gray.500">
                                        No translations
                                      </Text>
                                    )}
                                </Flex>
                              )}
                            </Td>
           <Td>
  {editableService && editableService.id === service.id ? (
    <Flex align="center">
      <Switch
        isChecked={editableService?.status === "on"} // Check if the status is "on"
        onChange={(e) =>
          setEditableService((prev) => ({
            ...prev,
            status: e.target.checked ? "on" : "off", // Convert boolean to "on" or "off"
          }))
        }
        colorScheme="cyan"
        mr={2}
      />
      <Badge
        colorScheme={editableService?.status === "on" ? "green" : "red"} // Check if the status is "on"
        variant="solid"
        px={2}
        py={1}
        borderRadius="md"
        fontSize="0.85em"
      >
        {editableService?.status === "on" ? t("Active") : t("Inactive")}
      </Badge>
    </Flex>
  ) : (
    <Badge
      colorScheme={service?.status === "on" ? "green" : "red"} // Check if the status is "on"
      variant="solid"
      px={2}
      py={1}
      borderRadius="md"
      fontSize="0.85em"
    >
      {service?.status === "on" ? t("Active") : t("Inactive")}
    </Badge>
  )}
</Td>

                  <Td>
                    {editableService && editableService.id === service.id ? (
                      <Flex>
                        <Button
                          colorScheme="green"
                          size="sm"
                          onClick={handleSaveService}
                          borderRadius="full"
                          boxShadow="md"
                          _hover={{ bg: "green.600", transform: "scale(1.05)" }}
                          _active={{ bg: "green.700", transform: "scale(0.95)" }}
                          transition="all 0.2s"
                          leftIcon={<MdDone />}
                        >
                          {t("Save")}
                        </Button>
                        <Button
                          colorScheme="red"
                          ml={2}
                          size="sm"
                          onClick={() => setEditableService(null)}
                          borderRadius="full"
                          boxShadow="md"
                          _hover={{ bg: "red.600", transform: "scale(1.05)" }}
                          _active={{ bg: "red.700", transform: "scale(0.95)" }}
                          transition="all 0.2s"
                          leftIcon={<MdCancel />}
                        >
                          {t("Cancel")}
                        </Button>
                      </Flex>
                    ) : (
                      <Flex>
                        <Button
                          colorScheme="cyan"
                          isDisabled={!permissions.canEdit}
                          size="sm"
                          color={"white"}
                          onClick={() => setEditableService(service)} // open modal
                          borderRadius="full"
                          boxShadow="md"
                          _hover={{ bg: "cyan.600", transform: "scale(1.05)" }}
                          _active={{ bg: "cyan.700", transform: "scale(0.95)" }}
                          transition="all 0.2s"
                          leftIcon={<MdEdit />}
                        >
                          {t("Edit")}
                        </Button>
                        {/* <Button
                          colorScheme="red"
                          size="sm"
                          isDisabled={!permissions.canDelete}
                          ml={2}
                          onClick={() => {
                            if (
                              window.confirm(
                                t("Are you sure you want to delete this service?")
                              )
                            ) {
                              handleDeleteService(service.id);
                            }
                          }}
                          borderRadius="full"
                          boxShadow="md"
                          color={"white"}
                          _hover={{ bg: "red.600", transform: "scale(1.05)" }}
                          _active={{ bg: "red.700", transform: "scale(0.95)" }}
                          transition="all 0.2s"
                          leftIcon={<MdDelete />}
                        >
                          {t("Delete")}
                        </Button>                         */}
                        <Button 
                          onClick={() => setSelectedServiceForItems(service)}
                          colorScheme="teal"
                          size="sm"
                          ml={2}
                          borderRadius="full"
                          boxShadow="md"
                          _hover={{ bg: "teal.600", transform: "scale(1.05)" }}
                          _active={{ bg: "teal.700", transform: "scale(0.95)" }}
                          transition="all 0.2s"
                          leftIcon={<IoMdEye />}
                        >
                          {t("Item")}
                        </Button>

                        <Button 
                         onClick={() => setSelectedServiceForCategories(service)}
                            colorScheme="cyan"
                          color="white"
                          p={4}
                          ml={4}
                                                    size="sm"

                          borderRadius="full"
                          boxShadow="md"
                          _hover={{ bg: "cyan.600", transform: "scale(1.05)" }}
                          _active={{ bg: "cyan.700", transform: "scale(0.95)" }}
                          transition="all 0.2s"
                          leftIcon={<MdCategory />}
                        >
                          {t("Categories")}
                        </Button>
                      </Flex>
                    )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Card>
      {/* Edit Service Modal */}
{editableService && (
  <Modal
    isOpen={true}
    onClose={() => setEditableService(null)}
    size="3xl"
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>
        <Text color="blue.500" fontSize="2xl" fontWeight="700">
          {t("Edit Service")}
        </Text>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <SimpleGrid columns={2} spacing={4}>
          {/* Service Name */}
          <FormControl isRequired>
            <FormLabel color="blue.600">{t("Service Name")}</FormLabel>
            <Input
              value={editableService.name || ""}
              onChange={(e) =>
                setEditableService({
                  ...editableService,
                  name: e.target.value,
                })
              }
            />
          </FormControl>

          {/* Description */}
          <FormControl>
            <FormLabel color="blue.600">{t("Description")}</FormLabel>
            <Textarea
          minH="40px"
                size="sm"
                borderRadius={"8px"}
              value={editableService.description || ""}
              onChange={(e) =>
                setEditableService({
                  ...editableService,
                  description: e.target.value,
                })
              }
            />
          </FormControl>

       

        
          {/* Translation Key (Disabled) */}
<FormControl>
  <FormLabel color="blue.600">{t("Translation Key")}</FormLabel>
  <Input
    value={editableService.translation_key || ""}
    isDisabled // Disable the input
  />
</FormControl>
{/* French Translation */}
<FormControl>
              <FormLabel color="blue.600">{t("Translation ")} 
                <Text 
                //bold text
                as="span" fontWeight="bold"
                >
                  {t("(French)")} 
                </Text>
              </FormLabel>
  <Input
    value={editableService.translations?.fr || ""}
    onChange={(e) =>
      setEditableService((prev) => ({
        ...prev,
        translations: {
          ...prev.translations,
          fr: e.target.value,
        },
      }))
    }
  />
</FormControl>
{/* Italian Translation */}
<FormControl>
              <FormLabel color="blue.600">{t("Translation ")}
                <Text 
                  as="span" fontWeight="bold"
                >
                  {t("(Italy)")} 
                </Text>
              </FormLabel>
  <Input
    value={editableService.translations?.it || ""}
    onChange={(e) =>
      setEditableService((prev) => ({
        ...prev,
        translations: {
          ...prev.translations,
          it: e.target.value,
        },
      }))
    }
  />
</FormControl>


   {/* Fee */}
          <FormControl>
            <FormLabel color="blue.600">{t("Fee")}</FormLabel>
            <Input
              type="number"
              min={0}
              value={editableService.fee || ""}
              onChange={(e) =>
                setEditableService({
                  ...editableService,
                  fee: e.target.value,
                })
              }
            />
          </FormControl>
          {/* Image Upload */}
          <FormControl>
            <FormLabel color="blue.600">{t("Service Image")}</FormLabel>
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setEditableService({
                      ...editableService,
                      image_url: reader.result,
                    });
                  };
                  reader.readAsDataURL(file);
                }
              }}
            />
          </FormControl>

          {/* Representative Image */}
          <FormControl>
            <FormLabel color="blue.600">{t("Representative Image")}</FormLabel>
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    setEditableService({
                      ...editableService,
                      representative_image: reader.result,
                    });
                  };
                  reader.readAsDataURL(file);
                }
              }}
            />
          </FormControl>
        </SimpleGrid>
  {/* Status Switch */}
          <FormControl mt={4}>
            <FormLabel color="blue.600">{t("Status")}</FormLabel>
            <HStack spacing={4}>
              <Switch
                isChecked={editableService.status === "on"}
                onChange={(e) =>
                  setEditableService({
                    ...editableService,
                    status: e.target.checked ? "on" : "off",
                  })
                }
                colorScheme="cyan"
              />
              <Badge
                colorScheme={editableService.status === "on" ? "green" : "red"}
                variant="solid"
                px={3}
                py={1}
                borderRadius="md"
              >
                {editableService.status === "on"
                  ? t("Active")
                  : t("Inactive")}
              </Badge>
            </HStack>
          </FormControl>
        {/* Image Preview Section */}
        <Box mt={8}>
          <Text fontWeight="bold" mb={2}>{t("Preview Images")}</Text>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
            {editableService.image_url && (
              <Box textAlign="center">
                <Text fontSize="sm" mb={1}>{t("Service Image")}</Text>
                <Image
                  src={editableService.image_url}
                  alt="Service"
                  maxH="120px"
                  mx="auto"
                  borderRadius="8px"
                />
              </Box>
            )}
            {editableService.representative_image && (
              <Box textAlign="center">
                <Text fontSize="sm" mb={1}>{t("Representative Image")}</Text>
                <Image
                  src={editableService.representative_image}
                  alt="Representative"
                  maxH="120px"
                  mx="auto"
                  borderRadius="8px"
                />
              </Box>
            )}
          </SimpleGrid>
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button
          colorScheme="cyan"
          color="white"
          isLoading={isSubmitting}
          onClick={handleSaveService}
        >
          {t("Save")}
        </Button>
        <Button
          onClick={() => setEditableService(null)}
          colorScheme="red"
          ml={3}
        >
          {t("Cancel")}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)}


    </>
  );
};

export default ListServices;
